import { render, staticRenderFns } from "./TranHistogram.vue?vue&type=template&id=7fa19fb5&scoped=true"
import script from "./TranHistogram.vue?vue&type=script&lang=js"
export * from "./TranHistogram.vue?vue&type=script&lang=js"
import style0 from "./TranHistogram.vue?vue&type=style&index=0&id=7fa19fb5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa19fb5",
  null
  
)

export default component.exports